<script setup lang="ts">
import './assets/style.scss'
import { useConfirm, VIcons } from '@/shared/ui'
import { useObjectTypeDelete } from './../model/api.ts'
import { useTranslate } from '@/shared/lib'

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  object_id: {
    type: String,
    required: true,
  },
})

const { trs } = useTranslate()
const { show } = useConfirm()
const emits = defineEmits(['deleted'])

const { remove, isPending } = useObjectTypeDelete(props.id, Number(props.object_id))

/**
 * Функция удаления типа инвентаризационного объекта
 */
const clickHandler = () => {
  show({
    confirmFunc: () => remove().then(() => emits('deleted')),
    title: trs('itf.object_types_delete'),
  })
}
</script>

<template>
  <VTooltip location="top" :open-delay="500" :text="$t('itf.delete')">
    <template #activator="{ props: tooltipProps }">
      <VBtn
        icon
        density="compact"
        color="error"
        :loading="isPending"
        v-bind="tooltipProps"
        @click="clickHandler"
      >
        <VIcons type="delete" />
      </VBtn>
    </template>
  </VTooltip>
</template>
